import { ValueOf } from 'Types';

import type { SelfieChallengeStatus } from 'Containers/SelfieChallenge/constants';

export const SELFIE_CHALLENGE_REQUIRED = 'challenge_required';
export const SELFIE_CHALLENGE_SUBMITTED = 'challenge_submitted';
export const SELFIE_VERIFICATION_REVIEW = 'in_review';
export const SELFIE_VERIFICATION_UNVERIFIED = 'not_verified';
export const SELFIE_VERIFICATION_VERIFIED = 'verified';

// Request Verification
export const SELFIE_VERIFICATION_ATTEMPTED = 'SELFIE_VERIFICATION_ATTEMPTED';

// Analytics value equivalent for "in_review"
const SELFIE_VERIFICATION_ANALYTICS_IN_PROGRESS = 'in_progress';

// For some of the selfie verification statuses, we must map the back-end value to the
// analytics value.
export const SELFIE_VERIFICATION_ANALYTICS_STATUSES_BY_SELFIE_VERIFICATION_STATUS = {
  [SELFIE_CHALLENGE_REQUIRED]: SELFIE_VERIFICATION_UNVERIFIED,
  [SELFIE_CHALLENGE_SUBMITTED]: SELFIE_VERIFICATION_ANALYTICS_IN_PROGRESS,
  [SELFIE_VERIFICATION_REVIEW]: SELFIE_VERIFICATION_ANALYTICS_IN_PROGRESS,
  [SELFIE_VERIFICATION_UNVERIFIED]: SELFIE_VERIFICATION_UNVERIFIED,
  [SELFIE_VERIFICATION_VERIFIED]: SELFIE_VERIFICATION_VERIFIED,
};

export type SelfieVerificationAnalyticsStatus = ValueOf<
  typeof SELFIE_VERIFICATION_ANALYTICS_STATUSES_BY_SELFIE_VERIFICATION_STATUS
>;
export type SelfieVerificationSuccessful = 'verified';
export type SelfieVerificationStatus = 'in_review' | 'not_verified' | 'verified';

export type SelfieVerificationStatuses = SelfieVerificationStatus[];

export type IdentityVerificationStatus = SelfieChallengeStatus | SelfieVerificationStatus;
